import styled from 'styled-components';
import theme from '../../styled/shared/Theme';

const StyledManageStudy = styled.div`
  .action-icon {
    font-size: ${theme.spacingM};
    margin-right: ${theme.spacingM};
  }
`;

export default StyledManageStudy;
